export function getEmbeddableUrl(rawUrl) {
  if (!rawUrl) return "";

  if (rawUrl.includes("youtube.com/watch?v=")) {
    const videoId = new URL(rawUrl).searchParams.get("v");
    return `https://www.youtube.com/embed/${videoId}`;
  }

  if (rawUrl.includes("vimeo.com")) {
     const cleanUrl = rawUrl.replace(/&amp;/g,"&");
    // 1° gruppo = videoId, 2° gruppo = hash (opzionale)
    const regex =
      /(?:player\.)?vimeo\.com\/(?:channels\/[\w]+\/)?(?:video\/)?(\d+)(?:\?h=([\w\d]+))?/;
    const match = cleanUrl.match(regex);

    if (match) {
      const videoId = match[1];
      const hash = match[2] || null;
      const embedUrl = hash
        ? `https://player.vimeo.com/video/${videoId}?h=${hash}`
        : `https://player.vimeo.com/video/${videoId}`;

      return embedUrl;
    }
  }

  return rawUrl;
}

